import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ApiServiceService } from "../../../Services/api-service.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { environment } from "src/environments/environment";
import { PublicPaymentModalComponent } from "../public-payment-modal/public-payment-modal.component";
import alertify from "alertifyjs";
import { finalize } from "rxjs";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { RemitaPaymentService } from "../../../Services/RemitaPaymentService";
import { ToastService } from "../../../Services/ToastService";
import { InvoiceValidationModalComponent } from "../invoice-validation-modal/invoice-validation-modal.component";

@Component({
  selector: "app-invoice-payment-page",
  templateUrl: "./invoice-payment-page.component.html",
  styleUrls: ["./invoice-payment-page.component.css"],
})
export class InvoicePaymentPage implements OnInit {
  verifyForm: FormGroup;
  invoiceValidationForm: FormGroup;
  invoicePaymentForm: FormGroup;

  mdaExtendedRevenue: any[] = [];
  mdaList: any[] = [];
  mdaRecord: any = {};
  invoiceRecord: any = {};
  asinDetails: any;
  isLoading: boolean = false;
  errorMessage: any;
  amount: number = 0;
  isVerifyingAsin: boolean = false;
  showAsinVerificationSuccessMessage: boolean;
  paymentType: string;
  invoiceDetailsProcessed: boolean = false;
  paymentMethod: string = 'interswitch';
  isSubmitting: boolean;
  merchantCode = environment.merchantCode;
  payItemId = environment.payItemId;
  interSwitchMode = environment.interSwitchMode;

  constructor(
    private modalService: BsModalService,
    private fb: FormBuilder,
    private apiService: ApiServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private remitaPaymentService: RemitaPaymentService,
    private spinner: ToastService,
  ) { 
            alertify.set("notifier", "position", "top-center");
    
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.paymentType = params.get("paymentType");
    });
    this.verifyForm = this.fb.group({
      email: ["", [Validators.required]],
      amount: ["", [Validators.required, Validators.min(1)]],
      asin: ["", [Validators.required]],
      phoneNumber: ["", [Validators.required]],
      mdaId: ["", [Validators.required]],
      revenueId: [""],
      revenueCode: ["", [Validators.required]],
      paymentMethod: [""]

    });

    this.getMdaList();

    if (this.paymentType == "invoice") {
      this.invoiceValidationForm = this.fb.group({
        invoiceNumber: ["", [Validators.required]],
      });

      this.invoicePaymentForm = this.fb.group({
        invoiceNumber: [{ value: "", disabled: true }, [Validators.required]],
        asin: [{ value: "", disabled: true }, [Validators.required, Validators.min(1)]],
        name: [{ value: "", disabled: true }, [Validators.required]],
        mda: [{ value: "", disabled: true }],
        revenueCode: [{ value: "", disabled: true }],
        amount: [{ value: "", disabled: true }],
        dateCreated: [{ value: "", disabled: true }],

      });
      this.openVerificationModal()

    }

  }

  get asinControl() {
    return this.verifyForm.get("asin");
  }

  get invoiceNumberControl() {
    return this.invoiceValidationForm.get("invoiceNumber");
  }

  private applyInvoiceDetails(invoiceDetails: any) {
    this.invoicePaymentForm.patchValue({
      invoiceNumber: invoiceDetails?.invoiceNumber,
      asin: invoiceDetails?.asin,
      name: invoiceDetails?.taxpayerName,
      mda: invoiceDetails?.mdaName,
      revenueCode: invoiceDetails?.revenueCode,
      amount: invoiceDetails?.invoiceAmount,
      dateCreated: invoiceDetails?.dateCreated,
    });
  }

  verifyAsin() {
    this.isVerifyingAsin = true;
    this.showAsinVerificationSuccessMessage = false;
    const url = "/assessments/get/asin?asin=" + this.verifyForm.value.asin;
    this.apiService
      .post(url, {})
      .pipe(
        finalize(() => {
          this.isVerifyingAsin = false;
        })
      )
      .subscribe({
        next: (asinData: any) => {
          if (asinData) {
            this.showAsinVerificationSuccessMessage = true;
          } else {
            this.verifyForm.get("asin").setErrors({ invalidASIN: true });
          }
        },
        error: (errors: any) => {
          this.verifyForm.get("asin").setErrors({ invalidASIN: true });
        },
      });
  }

  back () {
    this.router.navigate(['/'])
  }

  openVerificationModal() {
    let bsModalRef = this.modalService.show(InvoiceValidationModalComponent, {
      class: 'modal-md modal-dialog-centered ',
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      initialState: {
        callback: (response: any) => {

          const res = response;
          const invoiceDetails = res?.data?.data?.invoiceDetails;

          if(res.success){
            this.invoiceRecord = res;
            this.invoiceDetailsProcessed = true;
            this.isVerifyingAsin = false;
            this.applyInvoiceDetails(invoiceDetails);
  
            this.isLoading = false;
            this.amount = invoiceDetails?.invoiceAmount;
            bsModalRef.hide()
          }
          else {
            alertify.error('Error validating invoice number: ' + res.message)
          }
        }
      }
    });

  }

  getMdaRevenue(id: any) {
    const url = `/api/payment/split-account/all/revenues?id=${this.verifyForm.value.mdaId}`;
    this.apiService.PaymentGet(url).subscribe(
      (response) => {
        this.mdaExtendedRevenue = response;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getMdaList() {
    const url = "/api/payment/split-account/all/mda/list";
    this.apiService.PaymentGet(url).subscribe(
      (response) => {
        this.mdaList = response;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getMdaRecord(id: any) {
    this.mdaRecord = id;
  }

  isSubmittingAsinPayment: boolean;
  submit() {
    this.isSubmittingAsinPayment = true;
    const returnBackUrl = environment.url + "/payment/successful-payment";
    var details = {
      returnBackUrl: returnBackUrl,
      totalAmount: Number(this.verifyForm.value.amount.split(",").join("")),
      fullName: this.asinDetails.displayname,
      customerId: this.asinDetails.tinNumber,
      revenueName: this.mdaRecord.description,
      revenueId: this.mdaRecord.revenueCode,
      email: this.verifyForm.value.email,
      taxGroup: "INDIVIDUAL",
      feeDescription: this.mdaRecord.description,
      entityName: this.mdaRecord.description,
      phoneNumber: this.verifyForm.value.phoneNumber,
      entityType: "NON MDA",
      entityGroup: "FLAT",
      accessedBy: this.asinDetails.displayname,
      mdaRecordId: this.mdaRecord?.id,
    };

    if (this.paymentMethod == 'interswitch') {
      this.isSubmitting = true;
      this.startInterswitch(details);
    } else {
      this.isSubmitting = false;
      this.isSubmittingAsinPayment = false;
      alertify.set("notifier", "position", "top-center");
      alertify.error("Payment Gateway not available");
    }
  }

  isSubmittingInvoicePayment: boolean;
  submitInvoicePayment() {
    this.isSubmittingInvoicePayment = true;
  }

  clearInvoiceDetials() {
    this.invoiceDetailsProcessed = false;
    this.invoicePaymentForm.reset()
    this.openVerificationModal()
  }

  userDetailsValidated: boolean;


  validateUser() {

    this.userDetailsValidated = false;
    const url = "/assessments/get/asin?asin=" + this.verifyForm.value.asin;
    this.apiService.post(url, {}).subscribe(
      (res) => {
        if (res == null) {
          alertify.set("notifier", "position", "top-center");
          alertify.error("Invalid ASIN Number");
          return;
        }
        this.userDetailsValidated = true;
        this.asinDetails = res;
        this.isLoading = false;
        this.amount = this.verifyForm.value.amount.split(",").join("");
      },
      (error) => {
        alertify.set("notifier", "position", "top-center");
        alertify.error("Invalid ASIN Number");
        this.isLoading = false;
        this.errorMessage = error.error.message;
      }
    );
  }

  clear() {
    this.asinDetails = null;
    this.amount = 0;
  }

  getType(e: any) {
    this.paymentMethod = e.target.value;
  }


  startInterswitch(details: any) {
    this.spinner.spin()
    this.remitaPaymentService.startInterswitchInline(details).subscribe(
      response => {
        this.spinner.hide();
        this.isSubmitting = false;
        this.checkout(details, response);
      },
      error => {
        this.isSubmitting = false;
        console.info(`Remita Generate RRR error: ${error}`);
      });
  }

  checkout(details: any, interswitch: any) {
    console.log('details', details);
    console.log('interswitch', interswitch);

    var paymentRequest = {
      merchant_code: this.merchantCode,
      pay_item_id: this.payItemId,
      txn_ref: interswitch.orderId,
      cust_id: details.customerId,
      amount: Math.round((details?.totalAmount * 100 + Number.EPSILON) * 100) / 100,
      currency: '566',
      site_redirect_url: window.location.origin,
      onComplete: this.paymentCallback,
      mode: this.interSwitchMode,
      split_accounts: this.interSwitchMode == "LIVE" && !interswitch?.splitAccounts?.isEmpty ? JSON.stringify(interswitch?.splitAccounts) : ""
    };
    (window as any).webpayCheckout(paymentRequest);
  };

  
  paymentCallback(response: any) {
    console.log(response)
    if (response != null && parseFloat(response.amount) > 0) {
      sessionStorage.setItem('interResponse', JSON.stringify(response));
      setTimeout(() => {
        window.open("/payment/return-back/" + response.txnref
          + "/" + response.amount, "_self")
      }, 50);
    } if (response.txnref != null) {
      setTimeout(() => {
        window.open("/payment/return-back/" + response.txnref, "_self")
      }, 50);
    }
  }

  processInvoiceDetials() {
    this.userDetailsValidated = false;
    this.isVerifyingAsin = true;
    const url = "/assessments/pay/invoice?invoiceNumber=" + this.invoiceValidationForm.value.invoiceNumber;
    this.apiService.get(url, {}).subscribe(
      (res) => {
        this.invoiceRecord = res;
        this.invoiceDetailsProcessed = true;
        this.isVerifyingAsin = false;
        this.applyInvoiceDetails(res?.data?.data?.invoiceDetails);
        this.isLoading = false;
        this.amount = res?.data?.data?.invoiceDetails?.invoiceAmount;
      },
      (error) => {
        console.error('error', error)
        this.invoiceDetailsProcessed = true;
        this.isVerifyingAsin = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("An error occured");
        this.invoiceDetailsProcessed = false;
        this.isLoading = false;
        this.errorMessage = error.error.message;
      }
    );
  }

  submitInvoice() {
    this.isSubmittingInvoicePayment = true;
    const returnBackUrl = environment.url + "/payment/successful-payment";
    var details = {
      returnBackUrl: returnBackUrl,
      totalAmount: this.invoiceRecord?.data?.data?.invoiceDetails?.invoiceAmount,
      customerId: this.invoiceRecord?.data?.data?.invoiceDetails?.asin,
    };

    var interswitch = {
      totalAmount: this.invoiceRecord?.data?.data?.invoiceDetails?.invoiceAmount,
      customerId: this.invoiceRecord?.data?.data?.invoiceDetails?.asin,
      splitAccounts: this.invoiceRecord?.data?.data?.paymentDetails?.splitAccounts,
      orderId: this.invoiceRecord?.data?.data?.paymentDetails?.orderId
    }

    if (this.paymentMethod == 'interswitch') {
      this.isSubmitting = true;
      this.checkout(details, interswitch);
    } else {
      this.isSubmittingInvoicePayment = false;
      alertify.set("notifier", "position", "top-center");
      alertify.error("Payment Gateway not available");
    }
  }
}
